import { createService } from '../../api';
import { z } from 'zod';

export default createService({
  logRemote: {
    method: 'POST',
    url: '/Log',
    headers: {
      'application-name': 'Website',
    },
    responseSchema: z.object({}).optional(),
  },
});
